module.exports = __webpack_public_path__ + "static/media/AutoCAD Blockstream.6104eee3.png";